/**
 * Shared contact type definitions
 * Must match backend ALLOWED_CONTACT_TYPES in contact_log_service.py
 */
export const CONTACT_TYPES = ['Email', 'Phone', 'In-Person', 'Home Visit', 'School Visit'] as const;

export type ContactType = (typeof CONTACT_TYPES)[number];
